export default {
  PinInput: {
    baseStyle: {},
    sizes: {
      lg: {
        fontSize: 'xl',
        w: 14,
        h: 20,
        borderRadius: 'lg',
      },
      md: {
        fontSize: 'lg',
        w: 10,
        h: 14,
        borderRadius: 'md',
      },
    },
    variants: {
      outline: {
        color: 'gray.800',
        bgColor: 'white',
        border: 'light',
        borderColor: 'primary.base',
        _hover: {
          borderColor: 'secondary.tint',
        },
        _focus: {
          boxShadow: 'none',
          borderColor: 'secondary.tint',
        },
        _invalid: {
          boxShadow: 'none',
          borderColor: 'error',
        },
        _placeholder: {
          color: 'gray.700',
        },
      },
    },
    defaultProps: {},
  },
};
